import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import { when } from "lit/directives/when.js"
const { apiFetch } = window.wp

export class GoogleAnalytics extends LitElement {
	static properties = {
		orderId: { type: Number },
		orderEmail: { type: String },
	}

	constructor() {
		super()
		this.orderId = null
		this.orderEmail = null
	}

	connectedCallback() {
		super.connectedCallback()
		this.fetchOrderData()
	}

	async fetchOrderData() {
		if (!this.orderId) return

		try {
			// get key from URL
			const urlParams = new URLSearchParams(window.location.search)
			const key = urlParams.get("key")
			const orderData = await apiFetch({
				path: `/wc/store/v1/order/${this.orderId}?key=${key}&billing_email=${this.orderEmail}`,
				method: "GET",
			})
			this.trackPurchase(orderData)
		} catch (error) {
			console.error("Error fetching order data:", error)
		}
	}

	async trackPurchase(order) {
		console.log("Tracking purchase for order:", order)
		if (window.gtag && this.orderId) {
			const currency = order?.totals?.currency_code || "SEK";
			const items = (order.items || []).map((item, idx) => ({
				item_id: item.sku || item.id,
				item_name: item.name,
				quantity: item.quantity,
				price: parseFloat(item.totals?.line_total || item.prices?.price || 0) / Math.pow(10, item.totals?.currency_minor_unit || item.prices?.currency_minor_unit || 2),
				currency: item.totals?.currency_code || item.prices?.currency_code || currency,
				item_variant: item.variation?.map(v => v.value).join(", ") || undefined,
				item_brand: "Cirkularfabriken",
				item_category: undefined, // Could be set if category info is available
				index: idx,
				item_url: item.permalink,
				image_url: item.images?.[0]?.src,
			}))
			gtag("event", "purchase", {
				transaction_id: order.id,
				value: parseFloat(order?.totals?.total_price || 0) / Math.pow(10, order?.totals?.currency_minor_unit || 2),
				tax: parseFloat(order?.totals?.total_tax || 0) / Math.pow(10, order?.totals?.currency_minor_unit || 2),
				shipping: parseFloat(order?.totals?.total_shipping || 0) / Math.pow(10, order?.totals?.currency_minor_unit || 2),
				currency,
				coupon: (order.coupons && order.coupons.length > 0) ? order.coupons.map(c => c.code).join(",") : undefined,
				items,
			})
		}
	}

	render() {
		return html``
	}
}
